/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface UpdateUserProfileRequest
 */
export interface UpdateUserProfileRequest {
  /**
   * Имя, до 255 символов
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  name: string
  /**
   * Фамилия, до 100 символов
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  lastname?: string | null
  /**
   * Отчество, до 100 символов
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  patronymic?: string | null
  /**
   * Телефон: + и 11–13 цифр, уникален среди пользователей
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  phone: string
  /**
   * Тип организации (frontend-тип: физлицо / ИП / юрлицо)
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  organizationType: string
  /**
   * Данные организации — валидная JSON-строка
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  organizationData: string
}

/**
 * Check if a given object implements the UpdateUserProfileRequest interface.
 */
export function instanceOfUpdateUserProfileRequest(
  value: object
): value is UpdateUserProfileRequest {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('phone' in value) || value['phone'] === undefined) return false
  if (!('organizationType' in value) || value['organizationType'] === undefined)
    return false
  if (!('organizationData' in value) || value['organizationData'] === undefined)
    return false
  return true
}

export function UpdateUserProfileRequestFromJSON(
  json: any
): UpdateUserProfileRequest {
  return UpdateUserProfileRequestFromJSONTyped(json, false)
}

export function UpdateUserProfileRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateUserProfileRequest {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    lastname: json['lastname'] == null ? undefined : json['lastname'],
    patronymic: json['patronymic'] == null ? undefined : json['patronymic'],
    phone: json['phone'],
    organizationType: json['organizationType'],
    organizationData: json['organizationData'],
  }
}

export function UpdateUserProfileRequestToJSON(
  value?: UpdateUserProfileRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    lastname: value['lastname'],
    patronymic: value['patronymic'],
    phone: value['phone'],
    organizationType: value['organizationType'],
    organizationData: value['organizationData'],
  }
}
